import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import { ServiceNowIssue } from 'cmp-client-api';
import {
  Ticket,
  TicketPriorities,
  TicketStatuses,
} from '@src/domain/pages/support/tickets/tickets-dashboard/types/ticket.type';

const transformToApiModel = (issue: ServiceNowIssue): Ticket => ({
  resourceId: issue.resourceId,
  ticketTag: issue.ticketNumber,
  createdAt: new Date(issue.createdOn),
  lastResponseAt: new Date(issue.updatedOn),
  raisedBy: issue.raisedBy,
  shortDescription: issue.shortDescription,
  details: issue.description,
  type: issue.type,
  category: issue.category,
  subCategory: issue.subCategory,
  priority: issue.priority as TicketPriorities,
  status: issue.status as TicketStatuses,
  serviceName: issue.serviceName,
  holdReason: issue.holdReason,
  escalationTicketNumber: issue.escalationTicketNumber,
  relatedTicketNumber: issue.relatedTicketNumber,
});

export const SupportSystemTicketMapper: MapperInterface<ServiceNowIssue, Ticket> = {
  transformToApiModel,
};
